import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './EditMenu.module.scss';

const link = cx(styles.link, 'd-flex', 'align-items-center', 'px-3', 'py-2');

const EditMenu = ({ onEdit, isLoading }) => (
  <ul
    className={cx(styles.editMenu, 'radius-4', 'bg-white', 'py-2', 'px-0')}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    <li className={styles.listItem} onClick={!isLoading ? onEdit : undefined}>
      <div className={cx(link, { [styles.disabled]: isLoading })}>
        <i className={isLoading ? 'icon-loading icon-spin me-2' : 'icon-pencil-create me-2'} />
        {isLoading ? 'Loading...' : 'Change status'}
      </div>
    </li>
  </ul>
);

EditMenu.propTypes = {
  onEdit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

EditMenu.defaultProps = {
  isLoading: false,
};

export default EditMenu;
